import { Trans, useLingui } from "@lingui/react/macro"
import React from "react"

import {
  BriefCase,
  Charity,
  Group,
  Legal,
  Marketing,
  Research,
} from "../../../icon/icon-static-map"
import DropdownHighlight from "../dropdown-highlight"
import DropdownMain from "../dropdown-main"
import NavList from "../nav-list"
import NavListItem from "../nav-list-item"

const UseCasesDropdown = () => {
  const { t } = useLingui()

  return (
    <>
      <DropdownMain>
        <NavList rowsCount="two" title={t`Roles`}>
          <NavListItem
            href="/solutions/research-incentives"
            icon={<Research color="blue" size="small" />}
            label={<Trans>Research</Trans>}
            text={<Trans>Reward participants globally, for free</Trans>}
          />
          <NavListItem
            href="/solutions/sales-incentives"
            icon={<BriefCase color="magenta" size="small" />}
            label={<Trans>Sales</Trans>}
            text={<Trans>SPIFs and other incentives to boost sales</Trans>}
          />
          <NavListItem
            href="/solutions/marketing-incentives"
            icon={<Marketing color="gold" size="small" />}
            label={<Trans>Marketing</Trans>}
            text={<Trans>Incentivize action from demo to referral</Trans>}
          />
          <NavListItem
            href="/solutions/employee-incentives"
            icon={<Group color="orange" size="small" />}
            label={<Trans>HR</Trans>}
            text={<Trans>Employee rewards that improve engagement</Trans>}
          />
        </NavList>
        <NavList title={t`Industries`}>
          <NavListItem
            href="/solutions/nonprofits"
            icon={<Charity color="magenta" size="small" />}
            label={<Trans>Nonprofits</Trans>}
            text={<Trans>Reach communities, employees, & volunteers</Trans>}
          />
          <NavListItem
            href="/solutions/legal-disbursements"
            icon={<Legal color="blue" size="small" />}
            label={<Trans>Legal disbursements</Trans>}
            text={<Trans>Send funds to claimants in minutes</Trans>}
          />
        </NavList>
      </DropdownMain>
      <DropdownHighlight category="solutions" />
    </>
  )
}

export default UseCasesDropdown
